
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporate-design/tools-and-services",
      function () {
        return require("private-next-pages/corporate-design/tools-and-services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporate-design/tools-and-services"])
      });
    }
  